export default "__VITE_ASSET__44bb66e0__"